import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumericOnly]',
  standalone: true
})
export class NumericOnlyDirective {
  constructor(@Optional() private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const filtered = input.value.replace(/[^0-9]/g, '');
    
    input.value = filtered;
    
    if (this.ngControl?.control) {
      const control = this.ngControl.control;
      control.setErrors(null);
      control.markAsPristine();
      control.markAsUntouched();
      control.setValue(filtered, { emitEvent: false });
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity({ emitEvent: true });
    }
  }
}